import { render, staticRenderFns } from "./VersionManagement.vue?vue&type=template&id=ac06f06a&"
import script from "./VersionManagement.vue?vue&type=script&lang=js&"
export * from "./VersionManagement.vue?vue&type=script&lang=js&"
import style0 from "./VersionManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports